import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "gauge" }
const _hoisted_2 = {
  key: 0,
  class: "flight",
  viewBox: "0 0 100 60",
  preserveAspectRatio: "none"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = ["y1", "y2"]
const _hoisted_5 = ["cx", "cy"]
const _hoisted_6 = ["cx", "cy"]
const _hoisted_7 = { class: "gauge-mult mono" }
const _hoisted_8 = { class: "gauge-sub" }
const _hoisted_9 = {
  key: 1,
  class: "gauge-readout"
}
const _hoisted_10 = { class: "ro-chosen mono" }
const _hoisted_11 = { class: "rocket-controls" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "rocket-cashout-sats mono"
}
const _hoisted_15 = {
  key: 2,
  class: "rocket-settling"
}
const _hoisted_16 = { class: "settling-label" }
const _hoisted_17 = {
  key: 0,
  class: "rocket-hint"
}
const _hoisted_18 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rocket-skin", _ctx.gaugeClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showFlight)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
            (_ctx.flightPath)
              ? (_openBlock(), _createElementBlock("path", {
                  key: 0,
                  class: "flight-trail",
                  d: _ctx.flightPath
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("line", {
              class: "flight-lock",
              x1: "6",
              y1: _ctx.lockedY,
              x2: "94",
              y2: _ctx.lockedY
            }, null, 8, _hoisted_4),
            (!_ctx.busted)
              ? (_openBlock(), _createElementBlock("circle", {
                  key: 1,
                  class: "flight-head",
                  cx: _ctx.headX,
                  cy: _ctx.headY,
                  r: "1.6"
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.busted)
              ? (_openBlock(), _createElementBlock("circle", {
                  key: 2,
                  class: "flight-boom",
                  cx: _ctx.headX,
                  cy: _ctx.headY,
                  r: "2.2"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.gaugeText), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.gaugeSub), 1),
      (_ctx.showReadout)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, "YOU " + _toDisplayString(_ctx.lockedMult.toFixed(2)) + "×", 1),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ro-arrow" }, "→", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["ro-result mono", _ctx.resultClass])
            }, _toDisplayString(_ctx.resultText), 3)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.state.phase === 'idle' || _ctx.state.phase === 'resolved')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "rocket-btn launch",
            disabled: !_ctx.canLaunch,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLaunch && _ctx.onLaunch(...args)))
          }, _toDisplayString(_ctx.state.phase === 'resolved' ? 'LAUNCH AGAIN' : 'LAUNCH 🚀'), 9, _hoisted_12))
        : (_ctx.state.phase === 'climbing')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(["rocket-btn cashout", { armed: _ctx.canLockIn }]),
              disabled: !_ctx.canLockIn,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onLockIn && _ctx.onLockIn(...args)))
            }, [
              _createTextVNode(" LOCK IN @ " + _toDisplayString(_ctx.displayMult.toFixed(2)) + "× ", 1),
              (_ctx.cashoutSats !== null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.cashoutSats.toLocaleString()) + " sats ", 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_13))
          : (_ctx.state.phase === 'settling' || _ctx.state.phase === 'flipping')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, "LOCKED IN @ " + _toDisplayString(_ctx.lockedMult.toFixed(2)) + "×", 1),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "settling-dots" }, [
                  _createElementVNode("i"),
                  _createElementVNode("i"),
                  _createElementVNode("i")
                ], -1))
              ]))
            : _createCommentVNode("", true)
    ]),
    (_ctx.state.phase === 'climbing')
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (!_ctx.canLockIn)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "arming at " + _toDisplayString(_ctx.minMult.toFixed(2)) + "×…", 1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["hint-odds", { thin: _ctx.liveWinPct < 20 }])
                }, _toDisplayString(_ctx.liveWinPct.toFixed(0)) + "% to land", 3),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "hint-sep" }, "·", -1)),
                _createElementVNode("span", null, "auto-locks at " + _toDisplayString(_ctx.targetMult.toFixed(2)) + "×", 1)
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}